import { Block } from '@aloft/toolkit-sui';

export function Caret() {
  return (
    <Block
      position="absolute"
      top={0}
      right={0}
      width={0}
      height={0}
      borderStyle="solid"
      borderTopWidth="6px"
      borderTopColor="textSecondary"
      borderLeftWidth="6px"
      borderLeftColor="transparent"
    />
  );
}
